import { useMutation } from "@tanstack/react-query";

import { trackError } from "app/pages/sales-intelligence/utils/errors/tracking";
import { errorCategoryMap, SiError } from "app/pages/sales-intelligence/utils/errors/types";

import { API_SERVICE_BY_CRM } from "../constants";
import type { CrmProvider } from "../types/types";

type DownloadParams = {
    jobId: string;
    runId: string;
};

const useDownloadRunResultFile = (crmProvider: CrmProvider) => {
    return useMutation({
        mutationFn: async ({ jobId, runId }: DownloadParams) => {
            const url = await API_SERVICE_BY_CRM[crmProvider].getJobRunResultFileUrl(jobId, runId);

            const anchor = Object.assign(document.createElement("a"), {
                href: url,
                download: "",
                rel: "noopener noreferrer",
            });

            anchor.click();
        },
        onError(error) {
            trackError(
                new SiError(
                    "Failed to download the Job Run Logs file",
                    {
                        category: errorCategoryMap.api,
                    },
                    { cause: error },
                ),
            );
        },
    });
};

export default useDownloadRunResultFile;
